// Generated by CoffeeScript 1.12.7
var ModuleNotFound,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

module.exports = ModuleNotFound = (function(superClass) {
  extend(ModuleNotFound, superClass);

  function ModuleNotFound(module1, caller) {
    this.module = module1;
    this.caller = caller;
    this.message = 'Could not find any module with name ' + this.module;
    if (this.caller != null) {
      this.message = this.message + ', required from module ' + this.caller;
    }
  }

  return ModuleNotFound;

})(Error);
